@if (instalarApp.modo()) {
  <p-button
    type="button"
    label="Instalar aplicación"
    icon="pi pi-download"
    severity="danger"
    size="small"
    (onClick)="instalar()"
  />
}

<p-dialog
  header="Instalar Mayorap en el iPhone"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: 'min(100%, 26rem)' }"
  [breakpoints]="{ '640px': '95vw' }"
  [visible]="instruccionesIos()"
  (visibleChange)="instruccionesIos.set($event)"
>
  <ol class="m-0 pl-4 flex flex-column gap-3 line-height-3">
    <li>
      Tocá el botón <span class="font-semibold">Compartir</span>
      <i class="pi pi-upload mx-1" aria-hidden="true"></i>
      en la barra del navegador.
    </li>
    <li>Elegí <span class="font-semibold">Agregar a inicio</span>.</li>
    <li>Tocá <span class="font-semibold">Agregar</span> y abrí Mayorap desde el ícono nuevo.</li>
  </ol>
  <p class="m-0 mt-3 text-sm text-color-secondary">
    En iPhone, las notificaciones solo funcionan con la app abierta desde la pantalla de inicio.
  </p>

  <div class="flex justify-content-end pt-3">
    <p-button label="Entendido" (onClick)="instruccionesIos.set(false)" />
  </div>
</p-dialog>
